import { render } from "./ConversationReviewsList.vue?vue&type=template&id=ecc2ed24&scoped=true&lang=pug"
import script from "./ConversationReviewsList.vue?vue&type=script&lang=js"
export * from "./ConversationReviewsList.vue?vue&type=script&lang=js"

import "./ConversationReviewsList.vue?vue&type=style&index=0&id=ecc2ed24&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecc2ed24"]])

export default __exports__